import styled, { css } from 'styled-components';
export const RadioBase = styled.div `
  /*
   Make the element only as wide as the content.
  */
  display: inline-flex;
  flex-direction: column;

  line-height: 16px;
  font-size: 16px;
  font-family: 'Open Sans';
  color: var(--color-on-background);
  background: inherit;

  outline-offset: -3px;

  & input {
    position: absolute;
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    width: 1px;
    opacity: 0;
    overflow: hidden;
  }

  & > .hint {
    margin: -8px 0 16px 0;
  }

  ${({ $warning }) => $warning &&
    css `
      background: var(--color-warning-background);
      outline: 3px solid var(--color-warning-accent);
      padding: 0 32px 8px 0;

      & .box {
        background: var(--color-warning-background);
      }

      & > .hint {
        margin: -8px 0 16px 16px;
      }

      & > ${Options} {
        margin-left: 16px;
      }
    `}

  ${({ $error }) => $error &&
    css `
      background: var(--color-error-background);
      outline: 3px solid var(--color-error-accent);
      padding: 0 32px 8px 0;

      & .box {
        background: var(--color-error-background);
      }

      & > .hint {
        margin: -8px 0 16px 16px;
      }

      & > ${Options} {
        margin-left: 16px;
      }
    `}

  ${(props) => props['aria-disabled'] &&
    css `
      color: var(--color-disabled);
    `}
`;
export const MainLabel = styled.p `
  display: flex;
  align-items: center;

  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;

  margin-bottom: 16px;

  ${({ attention }) => attention &&
    css `
      margin: 0 16px 16px 16px;
    `}
`;
export const Attention = styled.div `
  display: flex;
  align-items: center;

  font-weight: 600;
  line-height: 24px;

  padding: 16px 24px 16px 16px;

  & > i {
    font-size: 24px;

    margin-right: 24px;

    ${({ $warning, $error }) => {
    /* eslint-disable indent */
    if ($warning)
        return 'color: var(--color-warning-accent)';
    if ($error)
        return 'color: var(--color-error-accent)';
    return '';
}}
  }
`;
export const Options = styled.div `
  display: inline-flex;
  flex-direction: column;

  & > .hint {
    margin: 8px 40px;

    & a {
      font-size: 14px;
    }
  }

  & > .box {
    & > label + label {
      margin-top: 8px;
    }

    & > input:focus + label {
      outline: var(--outline);
      z-index: 0;
    }

    & > input:focus:not(:focus-visible) + label {
      outline: 0;
      z-index: 0;
    }

    & > input:focus-visible + label {
      outline: var(--outline);
      z-index: 0;
    }
  }

  ${({ direction }) => direction === 'horizontal' &&
    css `
      flex-direction: row;

      & > .box + .box {
        margin-top: 0;
        margin-left: 16px;
      }
    `}
`;
export const Label = styled.label `
  display: flex;
  box-sizing: border-box;

  line-height: 24px;

  user-select: none;
  cursor: pointer;

  &:before {
    content: '';
    display: inline-flex;
    flex-shrink: 0;
    box-sizing: border-box;

    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin: 16px 16px 16px 0;

    border: 2px solid var(--color-on-background);
    background: var(--color-background);

    ${({ checked }) => checked &&
    /* eslint-disable indent */
    'border: 5px solid var(--color-selection)'}
  }

  ${(props) => props['aria-disabled'] &&
    /* eslint-disable indent */
    css `
      color: var(--color-disabled);
      cursor: not-allowed;

      &:before {
        border-color: var(--color-disabled);
      }
    `}
`;
export const LabelText = styled.div `
  padding: 12px 8px 8px 8px;
  line-height: 24px;
`;
export const Container = styled.div `
  display: flex;
  flex-direction: column;

  line-height: 24px;

  & > .hint {
    margin-top: 24px;
  }
`;
export const AriaInfo = styled.div `
  display: none;
`;
